export default __webpack_public_path__ + "static/media/STRIPAnimatGif-ForceBlack.fa62148e.gif";